<template>
  <b-card class="w-100" body-class="d-flex flex-grow-1 flex-column" v-loading="loading" :element-loading-text="loadingText">
    <div>
      <h4>
        <img src="/img/publishers/kijiji.png" height="50" alt="Kijiji" />
        <small v-if="!loading" class="pull-right">
          <b-badge v-if="account.active" variant="success">ACTIVE</b-badge>
          <b-badge v-else variant="danger">INACTIVE</b-badge>
        </small>
      </h4>

      <b-form @submit.prevent="login()">
        <div v-if="!loading" class="mt-4">
          <div v-if="account.active">
            <h5>Full Name</h5>
            <p v-if="account.name">{{account.name}}</p>
            <p v-else><em>(empty)</em></p>

            <h5>Email Address</h5>
            <p>{{account.username}}</p>
          </div>
          <div v-else>
            <b-form-group label="Email Address or Nickname">
              <b-form-input v-model="account.username" type="email" placeholder="eg. someone@example.com" required autocomplete="email" />
            </b-form-group>
            <b-form-group label="Password">
              <b-form-input v-model="account.password" type="password" placeholder="your password" required autocomplete="current-password" />
            </b-form-group>
          </div>
        </div>

        <div v-if="!loading" class="mt-4">
          <div v-if="account.active">
            <p class="mb-2">To change your login details, you must log out and reconnect</p>
            <b-button size="lg" variant="danger" @click="logout()">Logout &amp; Reconnect</b-button>
          </div>
          <div v-else>
            <p class="small">By clicking login below you authorize us to post your listings on Kijiji on your behalf as well as periodically collect advertisement statistics from your  We will <strong>never</strong> post anything on your account without your explicit consent. AdReplay&reg; does not store your account credentials after completing the login.</p>
            <b-button type="submit" size="lg" variant="primary">Login to Kijiji</b-button>
          </div>
          <b-alert :show="!!error" fade variant="danger" class="mt-4 mb-0">{{error}}</b-alert>
        </div>
      </b-form>
    </div>
  </b-card>
</template>

<script>
const LoadingText = 'Checking Kijiji Account Status...'
const UnlinkingText = 'Disconnecting Kijiji Account...'
const LinkingText = 'Connecting Kijiji Account...'

export default {
  name: 'PublishersKijiji',

  data(){
    return {
      account : {},

      // State
      loading     : false,
      loadingText : LoadingText,
      error       : ''
    }
  },

  mounted(){
    this.load()
  },

  methods: {
    load(){
      this.loading = true
      this.loadingText = LoadingText
      this.$API.v2.Publishers.Kijiji.Get()
      .then((kijiji) => {
        this.account = kijiji
        this.error = ''
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
    },

    logout(){
      // Confirm unlinking
      this.$swal({
        title              : 'Confirmation Required',
        text               : 'Are you sure you want to disconnect your Kijiji account? Any listings that have been setup for Kijiji will stop posting.',
        customClass        : 'confirm-modal',
        showCloseButton    : true,
        showCancelButton   : true,
        confirmButtonClass : 'bg-danger',
        confirmButtonText  : 'Yes, Disconnect Kijiji'
      })
      .then((result) => {
        if( result.dismiss ){
          return
        }

        this.loading = true
        this.loadingText = UnlinkingText
        this.$API.v2.Publishers.Kijiji.Disconnect()
        .then(() => {
          this.account = {}
          this.error = ''
        })
        .catch((err) => {
          this.error = err
        })
        .finally(() => {
          this.loading = false
        })
      })
      .catch(() => {})
    },

    login(){
      const { username, password } = this.account

      const firstListing = this.$session.get('dashboard.listing')

      // Prevent duplicate submit
      const $focus = document.querySelector(":focus")
      $focus && $focus.blur()

      if( this.loading ){
        return
      }

      this.loading = true
      this.loadingText = LinkingText
      this.$API.v2.Publishers.Kijiji.Connect(username, password)
      .then((kijiji) => {
        this.account = kijiji
        this.error = ''

        // First time connecting
        if( firstListing ){
          this.$nextTick(() => {
            this.$swal({
              title             : 'Connected to Kijiji!',
              text              : 'Look\'s like you\'re all set to post to Kijiji! Let\'s create your first listing.',
              type              : 'success',
              showCloseButton   : true,
              showCancelButton  : true,
              cancelButtonText  : 'Dismiss',
              confirmButtonText : 'Let\'s go'
            })
            .then((resp) => {
              if( resp.value ){
                this.$router.push({ name : "NewListing" })
              }
            })
          })
        }
      })
      .catch((err) => {
        this.error = err
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
};
</script>
